import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InsightsService } from '../../../services/insights-service';
import { UserService } from '../../../services/user-service';
import { RequestAccessModalComponent } from '../request-access-modal/request-access-modal.component';

export interface IInsightsDashboard {
  dashboardId: number;
  name: string;
  description: string;
  photo?: string;
  hasAccess: boolean;
}

@Component({
  selector: 'app-insights-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false,
})
export class WelcomeComponent implements OnInit {
  dashboards: IInsightsDashboard[] = [];
  isLoading = false;

  constructor(
    private router: Router,
    public insightsService: InsightsService,
    private userService: UserService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.insightsService.getMyDashboards().subscribe({
      next: (data) => {
        this.dashboards = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  onOpen(dashboard: IInsightsDashboard) {
    this.router.navigate(['/insights/dashboard', dashboard.dashboardId]);
  }

  onRequestAccess(dashboard: IInsightsDashboard) {
    const modal = this.modalService.open(RequestAccessModalComponent, { windowClass: 'request-access-modal' });
    modal.componentInstance.dashboardName = dashboard.name;
    modal.componentInstance.companyName = this.userService.company?.name || 'your organisation';

    modal.result.then(
      () => {
        // Modal handles the request-access API call and toasts on confirm; nothing else to do here.
      },
      () => {
      },
    );
  }
}
